import checkoutService from './services/checkout.service';
import suggestionsApiService from './services/suggestions.api.service';

let checkoutModule = angular.module('spabooker.admin.checkout', ['spabooker.basket', 'spabooker.shared.checkout'])
    .factory('checkout', checkoutService)
    .factory('suggestionsApiService', suggestionsApiService)
    ;

export default checkoutModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/checkout/index.js